import { axiosV2, getError, getResponse, settings } from '../../helpers/UtilsHelper';

const { app } = settings;
const { backend } = app;
const { urls } = backend;

export const ContactService = {
    /**
     * Send contact message
     * @param {Object} params
     * @param {Object} params.formData
     * @param {string} params.subMethod
     * @returns {Promise<Object>}
     */
    sendMessage: async ({
        formData = {},
        subMethod = ''
    } = {}) => {
        const currentMethod = 'ContactService.sendMessage';
        let response = getResponse({ type: 0 });
        try {
            response = await axiosV2?.post({
                url: `${urls?.url}${urls?.apiV1}${urls?.contactMessages}/sendMessage`,
                data: formData,
                subMethod: currentMethod
            });
            return response;
        } catch (ex) {
            return getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        }
    }
};
